import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { UmsService } from '../ums.service';
import { HttpErrorResponse, HttpClient } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PdfviewerComponent } from '../pdfviewer/pdfviewer.component';
import { MatDialog } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  studentId = sessionStorage.getItem('StudentRGID');
  @ViewChild(MatSort) sort: MatSort;
  addmissionData: any;
  StuIdd: string;
  StudentIdd: string;
  userId: string;
  Status: string;
  Comment: string;
  AdmFees: string;
  AdmPaidFees: string;
  ExmFees: string;
  ExmPaidFees: string;
  Name: string;
  Currency;
  ExamCurrency;
  ExamFee = true;
  ApplicationDetails;
  ShowDateData = true;
  redcolor = false;
  greenColor = false;
  blackColor = true;
  isDownloadEnabled: boolean = false;
  tableData: any[] = [
    { srNo: 1, activity: 'Registration', status: '', AppliDate: '' },
    { srNo: 2, activity: 'Registration Fees', status: '', AppliDate: '' },
    { srNo: 3, activity: 'Exam Form', status: '', AppliDate: '' },
    { srNo: 4, activity: 'Exam Fees', status: '', AppliDate: '' },
  ];
  tableData2: any[] = [
    // { srNo: 1, activity: 'Registration', status: '', AppliDate: '' },
    // { srNo: 2, activity: 'Admission Fees', status: '', AppliDate: '' },
    { srNo: 1, activity: 'Exam Form', status: '', AppliDate: '' },
    { srNo: 2, activity: 'Exam Fees', status: '', AppliDate: '' },
  ];
  data: any;
  InstId: any;
  SrNo = 0;
  EmId: any;
  addFeeDate;
  SessionNo: number;
  NotLeft = true;
  StuId: any;
  CertType: string;
  CertStatus: any;
  TclcDatas: any[];
  userType: string;
  ducumentList: any;
  Course: any;
  CourseLevel: any;
  College: any;
  StuRegYear: any;
  StudentRegNo : any;
  IsRegStudent : boolean = false;

  constructor(
    public umsService: UmsService,public router: Router,
    private spinner: NgxSpinnerService,private dialog: MatDialog,
    private http: HttpClient
  ) { }
  ngOnInit(): void {
    this.userType = this.umsService.getUserType();
    console.log('this.userType in home',this.userType);
    this.SrNo = 0;

    this.getStuId();
    // this.GetTclcData()
    this.getApplyData();
    this.Status = '';
    this.Comment = '';
    this.AdmFees = '';
    this.AdmPaidFees = '';
    this.ExmFees = '';
    this.ExmPaidFees = '';
    this.NotLeft = true;
    this.userId = sessionStorage.getItem('StudentRGID');
  }

  getTableData(StuId, CoCode, CgCode): void {
    if (this.SrNo == 1 || this.SrNo == 0) {
      this.tableData.forEach((item) => {
        switch (item.activity) {
          case 'Registration':
            this.getScrutiny(item);
            break;
          case 'Exam Form':
            this.getRgId(item, StuId);
            break;
          case 'Registration Fees':
            this.getFeeTempData(item, StuId, CoCode, CgCode);
            break;
          case 'Exam Fees':
            this.getFeeTempData2(item, StuId, CoCode, CgCode);
            break;
          default:
            console.error(`Unknown activity: ${item.activity}`);
        }
      });
    } else if (this.SrNo > 1) {
      this.tableData2.forEach((item) => {
        switch (item.activity) {
          // case 'Registration':
          //   this.getScrutiny(item);
          //   break;
          case 'Exam Form':
            this.getRgId(item, StuId);
            break;
          // case 'Admission Fees':
          //   this.getFeeTempData(item, StuId, CoCode, CgCode);
          //   break;
          case 'Exam Fees':
            this.getFeeTempData2(item, StuId, CoCode, CgCode);
            break;
          default:
            console.error(`Unknown activity: ${item.activity}`);
        }
      });
    }
  }

  // courseShId() {
  //   const payload = {};
  //   payload['CoCode'] = sessionStorage.getItem("StuCoId");
  //   payload['CShStatus'] = '';
  //   payload['LoginId'] = sessionStorage.getItem('userId');
  //   payload['CShSnNo'] =
  //   this.umsService.NewCoSch(payload).subscribe(res => {
  //     if (res.status) {
  //       this.checkRegister(res.data[0]['CShId'])
  //     }
  //   });
  // }
  // checkRegister(ShId) {
  //   const payload = {};
  //   payload['CEcInCode'] = 51;
  //   payload['CEcShId'] = ShId;
  //   payload['CEcOpId'] = sessionStorage.getItem('userId');
  //   this.umsService.getSupCourseEditRecord(payload).subscribe(res => {
  //     if (res.status) {
  //       if (res.data[0].CEcStatus == "U") {

  //       } else {
  //       }
  //     }
  //     else {
  //       let data = {}
  //       data['message'] = "Registration List Not Open"
  //       data['title'] = 'Information'
  //       data['icon'] = 'fas fa-check'
  //       this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //     }
  //   });
  // }

  getRgId2(StuId, CoCode, CgCode) {
    this.spinner.show();
    const payload = {};
    payload['StuId'] = StuId;
    this.umsService.RgId(payload).subscribe(
      (res) => {
        if (res.status) {
          this.spinner.hide();
          this.examform2(res.data[0]['RgId'], StuId, CoCode, CgCode);
          this.getTableData(StuId, CoCode, CgCode);
        } else {
          this.spinner.hide();
          this.getTableData(StuId, CoCode, CgCode);
        }
      },
      (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.getTableData(StuId, CoCode, CgCode);
      }
    );
  }

  getRgId(item, StuId) {
    this.spinner.show();
    const payload = {};
    payload['StuId'] = StuId;
    this.umsService.RgId(payload).subscribe((res) => {
      if (res.status) {
        this.examform(res.data[0]['RgId'], item);
        if (res.data[0]['RgStatus'] == 'L') {
          this.NotLeft = false;
        } else {
          this.NotLeft = true;
        }
      } else {
        if (item.activity === 'Exam Form') {
          item.status = 'Not Available';
        }
      }
    });
  }

  examform2(RgId, StuId, CoCode, CgCode) {
    this.spinner.show();
    const payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem('StuCoId');
    this.umsService.GetEcId(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        // this.SrNo = res.data[0]['EmSrNo']
        // this.getSubjectSelectionData()
        this.EmId = res.data[0]['EmId'];
        sessionStorage.setItem('EmSrNo', res.data[0]['EmSrNo']);
        this.getTableData(StuId, CoCode, CgCode);
        // this.ExmFrmEditListCo(res.data[0]['EmId'],item,res.data[0]['ShId'])
        if (this.SrNo == 1) {
          this.ShowDateData = true;
        } else if (this.SrNo > 1) {
          this.ShowDateData = false;
        }
      } else {
        this.spinner.hide();
      }
    });
  }

  examform(RgId, item) {
    this.spinner.show();
    const payload = {};
    payload['RgId'] = RgId;
    payload['CoCode'] = sessionStorage.getItem('StuCoId');
    this.umsService.GetEcId(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.loadExamRecords(res.data[0]['ShId'], item);
        // this.SrNo = res.data[0]['EmSrNo']
        // this.ExmFrmEditListCo(res.data[0]['EmId'],item,res.data[0]['ShId'])
      } else {
        this.spinner.hide();
        if (item.activity === 'Exam Form') {
          item.status = 'Not Available';
        }
        if (item.activity === 'Exam Fees') {
          item.status = 'Not Available';
          this.ExmPaidFees = ' ';
          this.ExamFee = false;
        }
      }
    });
  }

  loadExamRecords(Shid, item) {
    this.spinner.show();
    let payload = {};
    payload['EcShId'] = Shid;
    payload['EcInCode'] = ' ';
    payload['EcOpId'] = 0;
    this.umsService.getSupExamEditRecord(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        const ExmForm = res.data.filter((record) => record.EcInCode == 19);
        if (ExmForm.length != 0) {
          if (ExmForm[0]['EcStatus'] == 'U') {
            if (item.activity === 'Exam Form') {
              // item.status = 'Submitted'
              let payload2 = {};
              payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
              payload2['SessionId'] = sessionStorage.getItem('session');
              this.umsService
                .fetchApplicationDetails(payload2)
                .subscribe((res) => {
                  if (res.status) {
                    res.data.forEach((element) => {
                      if (element.ApplicationName == 'Exam Form') {
                        item.AppliDate = element.ApplicationSubDate;
                        if (element.ApplicationSubDate != '') {
                          item.status = 'Submitted';
                        }
                      }
                    });
                  } else {
                    item.status = 'Pending';
                  }
                });
            }
          } else if (ExmForm[0]['EcStatus'] == 'O') {
            if (item.activity === 'Exam Form') {
              // item.status = 'Pending'
              this.searchExams(item);
            }
          }
        } else if (ExmForm.length == 0) {
          if (item.activity === 'Exam Form') {
            item.status = 'Pending';
          }
        }
      } else {
        this.spinner.hide();
        if (item.activity === 'Exam Form') {
          item.status = 'Not Available';
        }
      }
    });
  }

  searchExams(item) {
    let payload = {};
    payload['RgNo'] = sessionStorage.getItem('StudentRGID');
    payload['CgCode'] = sessionStorage.getItem('StuCgId');
    payload['Valid'] = '';
    payload['Chng'] = '';
    payload['App'] = '';
    payload['EfId'] = 0;
    this.umsService.fetchInputExams(payload).subscribe((res) => {
      if (res.status) {
        res.data.forEach((element) => {
          if (this.EmId == element.EmId) {
            if (element.Valid == 'X') {
              if (item.activity === 'Exam Form') {
                item.status = 'Pending';
              }
            } else if (element.Valid == 'Y') {
              if (item.activity === 'Exam Form') {
                item.status = 'Submitted';
                let payload2 = {};
                payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
                payload2['SessionId'] = sessionStorage.getItem('session');
                this.umsService
                  .fetchApplicationDetails(payload2)
                  .subscribe((res) => {
                    res.data.forEach((element) => {
                      if (element.ApplicationName == 'Exam Form') {
                        item.AppliDate = element.ApplicationSubDate;
                      }
                    });
                  });
              }
            }
          } else {
            if (item.activity === 'Exam Form') {
              item.status = 'Pending';
            }
          }
        });
      } else {
        if (item.activity === 'Exam Form') {
          item.status = 'Pending';
        }
      }
    });
  }

  getSecretData() {
    let payload = {};
    this.umsService.getSecretData().subscribe((res) => {
      this.InstId = res.projectPharam['ClubPartTrans'];
    });
  }

  getdata(data) {
    this.umsService.getCurrentSession(data.projectPharam['SnNo'])
  }


  getScrutiny(item) {
    const payload = {};
    this.Status = 'Not Available';
    payload['StudentId'] = sessionStorage.getItem('StudentPersonalId');
    this.umsService.fetchScrutinyLock(payload).subscribe((res) => {
      if (item.activity === 'Registration') {
        if (res.status) {
          if (
            res.data[0]['Status'] == 'APPR' &&
            res.data[0]['FinalApproval'] == true
          ) {
            if (res.data[0]['UserId'] == res.data[0]['ApprovedBy']) {
              this.redcolor = false;
              this.greenColor = true;
              this.blackColor = false;
              item.status = 'Application Approved';
              this.Status = 'Application Approved';
              this.isDownloadEnabled = true;
              this.fetchDocument()
              this.Comment = 'Comments : ' + res.data[0]['Comment'];
            } else if (res.data[0]['UserId'] != res.data[0]['ApprovedBy']) {
              this.redcolor = false;
              this.greenColor = false;
              this.blackColor = true;
              this.Status = 'Application In Process';
              this.Comment = ' ';
              item.status = 'Application In Process';
            }
          } else if (
            res.data[0]['Status'] == 'APPR' &&
            res.data[0]['FinalApproval'] != true
          ) {
            this.redcolor = false;
            this.greenColor = false;
            this.blackColor = true;
            this.Status = 'Application In Process';
            this.Comment = ' ';
            item.status = 'Application In Process';
          } else if (res.data[0]['Status'] == 'DCERR') {
            this.redcolor = true;
            this.greenColor = false;
            this.blackColor = false;
            this.Status = 'Document Error';
            this.Comment = 'Comments : ' + res.data[0]['Comment'];
            item.status = 'Document Error';
          } else if (res.data[0]['Status'] == 'REJT') {
            this.redcolor = true;
            this.greenColor = false;
            this.blackColor = false;
            this.Status = 'Application Rejected';
            this.Comment = 'Comments : ' + res.data[0]['Comment'];
            item.status = 'Application Rejected';
          } else if (
            res.data[0]['Status'] == 'ReSubmitted' ||
            res.data[0]['Status'] == 'Submitted'
          ) {
            this.redcolor = false;
            this.greenColor = false;
            this.blackColor = true;
            this.Status = 'Approval In Process';
            this.Comment = ' ';
            item.status = 'Approval In Process';
          } else if (res.data[0]['Status'] == 'BCKP') {
            this.redcolor = false;
            this.greenColor = false;
            this.blackColor = true;
            this.Status = 'Application In Process';
            this.Comment = ' ';
            item.status = 'Application In Process';
          }
        } else {
          this.redcolor = false;
          this.greenColor = false;
          this.blackColor = true;
          this.Status = 'Application In Process';
          this.Comment = ' ';
          item.status = 'Application In Process';
        }
      }
    });
    let payload2 = {};
    payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
    payload2['SessionId'] = sessionStorage.getItem('session');
    this.umsService.fetchApplicationDetails(payload2).subscribe((res) => {
      res.data.forEach((element) => {
        console.log('registration',element)
        if (element.ApplicationName == 'Registration') {
          item.AppliDate = element.ApplicationSubDate;
        }
      });
    });
  }

  getFeeTempData(item, StuId, CoCode, CgCode) {
    const payload = {};
    payload['SessionId'] = this.SessionNo;
    payload['CoCode'] = CoCode;
    payload['CgCode'] = CgCode;
    payload['StuId'] = StuId;
    payload['FeeType'] = 'AF';
    this.umsService.SearchFeeAdm(payload).subscribe((res) => {
      if (res.status) {
        this.Name =
          res.data[0]['StuFirstNameEng'] +
          ' ' +
          res.data[0]['StuMidNameEng'] +
          ' ' +
          res.data[0]['StuLastNameEng'];
        this.Currency = res.data[0].Currency;
        sessionStorage.setItem('Currency', this.Currency);
        // this.SearchFeeDetails(res.data[0]['TemplateCode'], item, StuId)
        // if (this.SrNo > 1) {
        //   this.AdmFees = "Paid"
        //   this.AdmPaidFees = "Paid"
        //   this.Currency = '';
        //   if (item.activity === 'Admission Fees') {
        //     if (this.SrNo > 1) {
        //       item.status = "Paid"

        //       let payload2 = {};
        //       payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
        //       payload2['SessionId'] = parseInt(sessionStorage.getItem('session'))
        //       this.umsService.fetchApplicationDetails(payload2).subscribe((res) => {
        //         res.data.forEach(element => {
        //           if (element.ApplicationName == "Admission Fees") {
        //             item.AppliDate = element.ApplicationSubDate
        //             if(element.ApplicationSubDate != ''){
        //               item.status = "Paid"
        //             }
        //           }

        //         });
        //       })
        //     }

        //   }
        // }
        if (this.SrNo == 1 || this.SrNo == 0) {
          this.SearchFeeDetails(res.data[0]['TemplateCode'], item, StuId);
        } else if (this.SrNo > 1) {
          this.AdmPaidFees = 'Paid';
          this.AdmFees = 'Paid';
        }
      } else {
        this.Currency = '';
        if (item.activity === 'Registration Fees') {
          if (this.SrNo == 1 || this.SrNo == 0) {
            item.status = 'Not Available';
            this.AdmFees = 'Not Available';
          } else if (this.SrNo == undefined) {
            item.status = 'Not Available';
          }
        }
        if (this.SrNo > 1) {
          this.AdmFees = 'Paid';
        } else if (this.SrNo == 1) {
          this.AdmFees = 'Not Available';
        } else if (this.SrNo == undefined) {
          this.AdmFees = 'Not Available';
        }

        this.AdmPaidFees = ' ';
      }
    });
  }

  getFeeTempData2(item, StuId, CoCode, CgCode) {
    const payload = {};
    (payload['SessionId'] = this.SessionNo), (payload['CoCode'] = CoCode);
    payload['CgCode'] = CgCode;
    payload['StuId'] = StuId;
    payload['FeeType'] = 'EF';
    payload['EmId'] = this.EmId;
    this.umsService.fetchFeeTemp(payload).subscribe((res) => {
      if (res.status) {
        this.SearchFeeDetails2(res.data[0]['TemplateCode'], item, StuId);
        this.ExamCurrency = res.data[0].Currency;
        sessionStorage.setItem('ExamCurrency', this.ExamCurrency);
      } else {
        this.ExamCurrency = '';
        this.ExmFees = 'Not Available';
        this.ExmPaidFees = ' ';
        if (item.activity === 'Exam Fees') {
          item.status = 'Not Available';
        }
      }
    });
  }

  SearchFeeDetails2(TempCode, item, StuId) {
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StuId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.SessionNo;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      if (res.status) {
        this.ExamFee = true;
        let data = res.data[0];
        let totalFeeAmount = res.data.reduce(
          (total, item) => total + item.FeeAmt,
          0
        );
        this.ExmFees = totalFeeAmount; // "Total Fees : " +
        this.ExmPaidFees = data.TotalPaidAmount; // "Fees Paid : " +
        if (item.activity === 'Exam Fees') {
          if (totalFeeAmount == data.TotalPaidAmount) {
            item.status = 'Paid';
            let payload2 = {};
            payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
            payload2['SessionId'] = sessionStorage.getItem('session');
            this.umsService
              .fetchApplicationDetails(payload2)
              .subscribe((res) => {
                res.data.forEach((element) => {
                  if (element.ApplicationName == 'Exam Fees') {
                    item.AppliDate = element.ApplicationSubDate;
                  }
                });
              });
          } else if (totalFeeAmount != data.TotalPaidAmount) {
            item.status = 'Pending';
          }
        }
      } else {
        this.ExamFee = false;
        this.ExmFees = 'Pending';
        this.ExmPaidFees = ' ';
        if (item.activity === 'Exam Fees') {
          item.status = 'Pending';
          this.ExmPaidFees = ' ';
          this.ExamFee = false;
        }
      }
    });
  }

  SearchFeeDetails(TempCode, item, StuId) {
    const payload = {};
    // payload['TemplateCode'] =  this.tempCo;
    payload['FeeTemplateCode'] = TempCode;
    payload['StuId'] = StuId;
    payload['FeeHistory'] = 0;
    payload['SnNo'] = this.SessionNo;
    this.umsService.getSearchFeeDetails(payload).subscribe((res) => {
      if (res.status) {
        this.ExamFee = true;
        let data = res.data[0];
        let totalFeeAmount = res.data.reduce(
          (total, item) => total + item.FeeAmount,
          0
        );
        this.AdmFees = totalFeeAmount; //"Total Fees : " +
        this.AdmPaidFees = data.TotalPaidAmount; //"Fees Paid : " +
        if (item.activity === 'Registration Fees') {
          if (totalFeeAmount == data.TotalPaidAmount) {
            item.status = 'Paid';
            let payload2 = {};
            payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
            payload2['SessionId'] = sessionStorage.getItem('session');
            this.umsService
              .fetchApplicationDetails(payload2)
              .subscribe((res) => {
                res.data.forEach((element) => {
                  console.log('element',element)
                  if (element.ApplicationName == 'Admission Fees') {
                    item.AppliDate = element.ApplicationSubDate;
                    console.log('item.AppliDate',item.AppliDate)
                    this.addFeeDate = element.ApplicationSubDate;
                    if (element.ApplicationSubDate != '') {
                      item.status = 'Paid';
                    }
                  }
                });
              });
          } else if (totalFeeAmount != data.TotalPaidAmount) {
            item.status = 'Pending';
          }
        }
      } else {
        this.ExamFee = false;
        this.AdmFees = 'Pending';
        this.AdmPaidFees = ' ';
        if (item.activity === 'Registration Fees') {
          if (this.addFeeDate != '' && this.addFeeDate != undefined) {
            item.status = 'Paid';
          } else {
            item.status = 'Pending';
          }
          this.ExamFee = false;
        }
      }
    });
  }

  prepopulation() {    
    // this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = this.studentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      if (res.status) {
        if (res.data.length > 0) {
          sessionStorage.setItem('StudentPersonalId', res.data[0].StuId);
          this.StuId = res.data[0].StuId
          this.prepopulationOfAddmission(res.data[0].StuId);
          this.prepopulationOfPhotoSign();

          this.getUserData(sessionStorage.getItem('StudentRGID'));
          // this.GetTclcData()
          this.getSecretData();
          this.getApplicationDetails();
        }
      }
    });
  }
  getUserData(id) {
    // sessionStorage.clear();

    this.umsService.getUserData(id).subscribe((res) => {
      // this.userData = res.data[0][0];
      // this.userForProfile = res.data[0][0].LoginName;
      let data = res.data[0][0].LoginName;
      sessionStorage.setItem('LoginNamePrf', data);
    });
  }

  prepopulationOfAddmission(StuId) {
    // this.spinner.show();
    this.StudentIdd = sessionStorage.getItem('StudentPersonalId');
    let payload = {};
    payload['StuId'] = this.StudentIdd;
    this.umsService.fetchAddmissionDetails(payload).subscribe((res) => {
      if (res.status) {
        this.addmissionData = res.data[0];
        this.getRgId2(StuId, res.data[0].StuCoId, res.data[0].StuCgId);
        sessionStorage.setItem('faculty', res.data[0].StuFacId);
        sessionStorage.setItem('StuCoId', res.data[0].StuCoId);
        sessionStorage.setItem('StuCgId', res.data[0].StuCgId);
      }
    });
  }

  prepopulationOfPhotoSign() {
    // this.spinner.show();
    this.StudentIdd = sessionStorage.getItem('StudentPersonalId');
    let payload = {};
    payload['StuId'] = this.StudentIdd;
    this.umsService.fetchPhotoSignDetails(payload).subscribe((res) => {
      if (res.data[0].StuPhoto !== null) {
        this.umsService.getImage(res.data[0].StuPhoto);
        sessionStorage.setItem('ProfileImg', res.data[0].StuPhoto);
      } else {
        let img = '../../assets/images/user2.png';
        // this.umsService.getImage(img)
        this.umsService.getNoimg(img);
        sessionStorage.setItem('ProfileImg', img);
      }
    });
  }

  getApplicationDetails() {
    // let payload = {};
    // payload['StuId'] = sessionStorage.getItem('StudentPersonalId')
    // this.umsService.fetchApplicationDetails(payload).subscribe((res) => {
    // this.ApplicationDetails = res.data;
    // })
  }

  getStuId() {
    // this.spinner.show();
    let payload = {};
    payload['StuRgNo'] = this.studentId;
    this.umsService.fetchPersonalDetails(payload).subscribe((res) => {
      this.StuId = res.data[0].StuId;
      this.StuRegYear = res.data[0].StuRegYear;
      this.StudentRegNo = res.data[0].StudentRegNo;
      this.IsRegStudent = res.data[0].IsRegStudent;
      this.SubjectSelectionData(res.data[0].StuId);
    });
  }

  getSubjectSelectionData() {
    const payload = {};
    payload['StuId'] = sessionStorage.getItem('StudentPersonalId');
    (payload['SubSession'] = parseInt(sessionStorage.getItem('session'))),
      this.umsService.getSubSelectionDetails(payload).subscribe((res) => {
        if (res.status) {
          this.getExam(
            parseInt(res.data[0]['SubEmId']),
            res.data[0]['SubCoId']
          );
        } else {
          this.SrNo = 0;
          this.prepopulation();
        }
      });
  }

  SubjectSelectionData(StuId) {
    const payload = {};
    payload['StuId'] = StuId;
    this.umsService.StudentSubjectSelectionById(payload).subscribe((res) => {
      if (res.status) {
        const latestObject = res.data[res.data.length - 1];
        this.getExam(
          parseInt(latestObject['SubEmId']),
          latestObject['SubCoId']
        );
        this.SessionNo = parseInt(latestObject['SubSession']);
      } else {
        this.SessionNo = parseInt(sessionStorage.getItem('session'));
        this.SrNo = 0;
        this.prepopulation();
      }
    });
  }

  getExam(EmId, CoCode) {
    const payload = {};
    payload['EmCoCode'] = CoCode;
    payload['EmId'] = EmId;
    this.umsService.ExamFetch(payload).subscribe((res) => {
      this.SrNo = res.data[0]['EmSrNo'];
      this.prepopulation();
    });
  }

  GetTclcData() {

    this.spinner.show();
    let payload = {};
    payload['SessionId'] = sessionStorage.getItem('session');
    payload['CertType'] = 'All';
    payload['IsStudent'] = 1
    payload['StuId'] = this.StuId
    this.umsService.GetTclcData(payload).subscribe((res) => {

      this.spinner.hide();
      if (res.status) {


        let TclcData = []
        // TclcData = res.data.filter(data => data.StuId == sessionStorage.getItem('StudentRGID'))
        TclcData = res.data
        this.TclcDatas = TclcData
        console.log(this.TclcDatas);

        if (TclcData.length != 0) {

          switch (TclcData[0]['CertStatus']) {
            case "APR":
              this.CertStatus = 'Provisional Certificate Downloaded By Institute'
              break;
            case "APPAP":
              if (TclcData[0]['CertType'] == "ADMC") {
                if (TclcData[0]['RgStatus'] == "L") {
                  this.CertStatus = 'Application Approved'
                }
                else if (TclcData[0]['RgStatus'] == " ") {
                  this.CertStatus = 'Application InProcess'
                }
              }
              else {
                this.CertStatus = 'Application Approved'
              }

              break;
            case "REJ":
              this.CertStatus = 'Rejected'
              break;
            case "REC":
              this.CertStatus = 'Rectify';
              break;
            case "ReSubmitted":
              if (TclcData[0]['CertStatus'] == 'ReSubmitted' && TclcData[0]['FeeStatus'] == 'Y') {
                this.CertStatus = 'Fees Paid'
              }
              else {
                this.CertStatus = 'Re-Submitted'
              }
              break;
            case "Submitted":
              this.CertStatus = 'Submitted'
              break;
            case "UFD":
              this.CertStatus = 'TS Certificate Generated'
              break;
            default:
              this.CertStatus = TclcData[0]['CertStatus']
              break
          }
          TclcData.forEach((item) => {
            switch (item.CertType) {
              case 'PC':
                this.CertType = 'Provisional Passing Certificate';
                break;
              case 'OPC':
                this.CertType = 'Original Passing Certificate';
                break;
              case 'MC':
                this.CertType = 'Migration Certificate';
                break;
              case 'RC':
                this.CertType = 'Rank Certificate';
                break;
              default:
                this.CertType = 'Not Applied';
            }
          });
          this.getDate()
        }
        else {
          this.CertType = 'Not Applied';
          this.CertStatus = 'Not Available'
        }

        if (this.CertType != 'Not Applied' && this.CertStatus != 'Not Available') {


        }




      }
      else {
        this.CertType = 'Not Applied';
        this.CertStatus = 'Not Available'
      }
    });
  }

  // getCertTypesTooltip(): string {
  //   // Map each CertType to its full name and join them with a comma
  //   return this.TclcDatas
  //     .map(data => {
  //       // Check the CertType and return the corresponding full name
  //       switch (data.CertType) {
  //         case 'PC':
  //           return 'Provisional Passing Certificate';
  //         case 'OPC':
  //           return 'Original Passing Certificate';
  //         case 'MC':
  //           return 'Migration Certificate';
  //         case 'RC':
  //           return 'Rank Certificate';
  //         default:
  //           return 'Not Applied';  // Default for other CertType values
  //       }
  //     })
  //     .join(', ');  // Join the resulting full names with a comma
  // }

  getDate() {
    let payload2 = {};
    payload2['StuId'] = sessionStorage.getItem('StudentPersonalId');
    payload2['SessionId'] = sessionStorage.getItem('session');
    this.umsService.fetchApplicationDetails(payload2).subscribe((res) => {
      if (res.status) {
        console.log('application details fetch',res.data);
        console.log('this.TclcDatas',this.TclcDatas);
        let srNoCounter = 5;
        res.data.forEach(element => {
          this.TclcDatas.forEach((TclcElement,index) => {
          
            if (element.ApplicationName == TclcElement['CertType']) {
              let Certificate
              let Status
              switch (TclcElement['CertType']) {
                case 'PC':
                  Certificate = 'Provisional Passing Certificate';
                  break;
                case 'OPC':
                  Certificate = 'Original Passing Certificate';
                  break;
                case 'MC':
                  Certificate = 'Migration Certificate';
                  break;
                case 'RC':
                  Certificate = 'Rank Certificate';
                  break;
                default:
                  Certificate = 'Not Applied';
              }


              switch (TclcElement['CertStatus']) {
               
                case "APPAP":
                  Status = 'Application Approved'
                  break;
                case "REJ":
                  Status = 'Rejected'
                  break;
                case "REC":
                  Status = 'Rectify';
                  break;
                case "ReSubmitted":
                  Status = 'Re-Submitted'
                  break;
                case "Submitted":
                  Status = 'Submitted'
                  break;
                case "Fees Paid":
                  Status = 'Fees Paid'
                  break;
                default:
                  this.CertStatus = TclcElement['CertStatus']
                  break
              }

             

              const newRow = {
                srNo: srNoCounter++, // or dynamically calculated based on your logic
                activity: Certificate, // your dynamic activity
                status: Status, // from API response
                AppliDate: element.ApplicationSubDate // from API response
              };
              // Push the new row into the tableData array
              this.tableData.push(newRow);
            }
          });
          
        });
      }

    })
  }


  generateQRBase64(): Promise<string> {
    this.spinner.show();
    const encryptionKey = 'abc123'; // ?? Move to env later

    // Collect required data
    const payload = {
      LoginId: parseInt(sessionStorage.getItem('StudentRGID') || '0', 10),
      RptCode: 311,
      InstNo: this.InstId ? this.InstId : 0,
      SnNo: this.SessionNo,
      Stuid: parseInt(sessionStorage.getItem('StudentPersonalId') || '0', 10)
    };

    // Encrypt payload
    let encryptedData = CryptoJS.AES.encrypt(
      JSON.stringify(payload),
      encryptionKey
    ).toString();

    // Make URL safe
    encryptedData = encryptedData.replace(/\//g, '~');

    // Build API URL with ?mode=qr
    const apiUrl = `${environment.serviceUrl}/abcID/generateReport/${encodeURIComponent(encryptedData)}?mode=qr`;

    return new Promise((resolve, reject) => {
      this.http.get<{ success: boolean; qrBase64: string }>(apiUrl).subscribe({
        next: (res) => {
          this.spinner.hide();
          if (res.success) {
            // ?? remove "data:image/png;base64," prefix
            const cleanBase64 = res.qrBase64.replace(/^data:image\/png;base64,/, '');
            resolve(cleanBase64);
          } else {
            reject('QR generation failed');
          }
        },
        error: (err) => {
          this.spinner.hide();
          console.error('? API call failed:', err);
          reject(err);
        }
      });
    });
  }


  async printData() {
    // this.submitpayload = this.ReportForm.value;
     const qrBase64 = await this.generateQRBase64();
    // alert("outside generateQR function")
    // return;
    var filter: any;
      let payload1 = {}
      payload1['Stuid'] = parseInt(sessionStorage.getItem('StudentPersonalId'));
      payload1['QRBase64'] = qrBase64

      let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
      var filter: any;
 
    var filter: any;
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('StudentRGID')) ? parseInt(sessionStorage.getItem('StudentRGID')) : 0,
      "RptCode": this.CourseLevel=== 'phd' ? 312 : 311,
      "InstName": '',
      "InstNo": this.InstId ? this.InstId : 0,
      "ShId": '',
      "CgCode": '',
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',//this.emid
      "CsNo": '',
      "PgBreak": '',
      "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": '', //this.submitpayload['course'] ? this.submitpayload['course'] : 0,
      "SnNo": this.SessionNo,
      "Extra1": JSON.stringify(payload1),
    }
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }
 
  redirect(to): void {
    this.router.navigate([to]);
  }

  fetchDocument() {
    this.spinner.show();
    let payload = {};
    payload['StuId'] = parseInt(sessionStorage.getItem('StudentPersonalId'));
    this.umsService.fetchDocumentDetails(payload).subscribe((res) => {
      this.spinner.hide();
      this.ducumentList = res.data;
      console.log('this.ducumentList', this.ducumentList);
      console.log('this.ducumentList[0].HardCopyFile',this.ducumentList[0]);
        
      //sessionStorage.setItem("StuDocId",res.data[0].StuDocId);

    });
  }

  downloadData(){
    const dialogRef3 = this.dialog.open(PdfviewerComponent,
      {
        width: "400px",
        height: "500px",
        data: this.ducumentList[0].HardCopyFile
      });
  }
     getApplyData() {
    let payload = {}
    payload['LoginId'] = sessionStorage.getItem('loginId');
    this.umsService.getApplyData(payload).subscribe((res) => {
      console.log('res.data',res.data)
      if (res.status) {
        this.Course = res.data[0]['CoName'];
        this.College = res.data[0]['CgName'];
        this.CourseLevel = res.data[0]['CourseLevel'];
       
      }
      else {
        
      }
    }, (ERROR: HttpErrorResponse) => {
      
    });
  }
}